import Vue from 'vue'
import Vuex from 'vuex'
import {getUsername} from '@/assets/js/common.js'

Vue.use(Vuex)

const state = {
    username: '',
    permission: {
        create: false,
        update: false,
        delete: false
    },
    branch: []
}

const getters = {
    getUser: (state) => {
        return state.username ? state.username : getUsername();
    }
}

const mutations = {
    setUser(state, username) {
        state.username = username;
    },
    setPermission(state, perm) {
        state.permission = perm;
    },
    setBranch(state, branch) {
        state.branch = branch;
    }
}

const actions = function({commit}, username) {
    commit('setUser', username);
}

export default new Vuex.Store({
    actions,
    getters,
    state,
    mutations
  });